import React, { useContext } from 'react';

import { ToolbarContext } from './../../ricos-context';
import type { IToolbarItem } from './../../ricos-types';
import { ToolbarButton } from './../../toolbars-ui';

export const RemoveLinkButton = ({ toolbarItem }: { toolbarItem: IToolbarItem }) => {
  const { t, isMobile } = useContext(ToolbarContext);

  //TODO: move translation to toolbar entity and use entity here
  const tooltip = t(toolbarItem.presentation?.tooltip);
  const dataHook = toolbarItem.presentation?.dataHook;

  return (
    <ToolbarButton
      isMobile={isMobile}
      tooltip={tooltip}
      onClick={() => {
        toolbarItem.commands.click();
      }}
      Icon={toolbarItem.presentation?.icon}
      dataHook={dataHook}
    />
  );
};
